/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PecegepayCreditcardCoursefinpersonpaymentid200,
  GetApiV1PecegepayCreditcardCoursefinpersonpaymentid401,
  GetApiV1PecegepayCreditcardCoursefinpersonpaymentid404,
  GetApiV1PecegepayCreditcardCoursefinpersonpaymentid500,
  GetApiV1PecegepayCreditcardCoursefinpersonpaymentidPathParams,
  GetApiV1PecegepayCreditcardCoursefinpersonpaymentidQueryResponse,
} from "../../types/pecegePayCreditCardController/GetApiV1PecegepayCreditcardCoursefinpersonpaymentid.ts";
import { creditCardOrderResponseViewModelSchema } from "../creditCardOrderResponseViewModelSchema.ts";

export const getApiV1PecegepayCreditcardCoursefinpersonpaymentidPathParamsSchema =
  z.object({
    courseFinPersonPaymentId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1PecegepayCreditcardCoursefinpersonpaymentidPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PecegepayCreditcardCoursefinpersonpaymentid200Schema =
  z.lazy(
    () => creditCardOrderResponseViewModelSchema,
  ) as unknown as ToZod<GetApiV1PecegepayCreditcardCoursefinpersonpaymentid200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PecegepayCreditcardCoursefinpersonpaymentid401Schema =
  z.any() as unknown as ToZod<GetApiV1PecegepayCreditcardCoursefinpersonpaymentid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1PecegepayCreditcardCoursefinpersonpaymentid404Schema =
  z.any() as unknown as ToZod<GetApiV1PecegepayCreditcardCoursefinpersonpaymentid404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PecegepayCreditcardCoursefinpersonpaymentid500Schema =
  z.any() as unknown as ToZod<GetApiV1PecegepayCreditcardCoursefinpersonpaymentid500>;

export const getApiV1PecegepayCreditcardCoursefinpersonpaymentidQueryResponseSchema =
  z.lazy(
    () => getApiV1PecegepayCreditcardCoursefinpersonpaymentid200Schema,
  ) as unknown as ToZod<GetApiV1PecegepayCreditcardCoursefinpersonpaymentidQueryResponse>;
